import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TextField, Grid2 as Grid, FormGroup, Grid2Props } from "@mui/material";
import { singleGridItem } from "../defaultStyles";
import clsx from "clsx";
import FormLabel from "../../common/base/FormLabel";
import UserAttributeMetadataPaper from "../../attributeMetadata/UserAttributeMetadataPaper";
import { useInputFullName } from "../subForms/NamePrefixContext";
import { useFormHandlerContext } from "../../../../controllers/formController";

export interface FormTextFieldProps extends Grid2Props {
  name?: string;
  label: string;
  labelActions?: React.ReactNode;
  static?: boolean;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  multiline?: boolean;
  rows?: number;
  textParser?: (text: string) => string;
  validate?: (value: any) => string | boolean;
}

const FormTextField: React.FC<FormTextFieldProps> = ({
  name,
  label,
  labelActions,
  required = false,
  static: isStatic = false,
  disabled = false,
  placeholder,
  multiline = false,
  rows = 3,
  textParser,
  validate,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();
  const { control } = useFormContext();
  const fullName = useInputFullName(name);
  return (
    <Grid {...singleGridItem} {...grid}>
      <UserAttributeMetadataPaper name={fullName}>
        <Controller
          name={fullName}
          control={control}
          rules={{
            required: required ? `${label} is required` : false,
            validate,
          }}
          render={({ field, fieldState }) => (
            <FormGroup>
              <FormLabel
                required={required}
                name={fullName}
                label={label}
                actions={labelActions}
              />
              <TextField
                {...field}
                className={clsx(grid.className, isStatic && "Mui-static-field")}
                id={fullName}
                placeholder={placeholder}
                fullWidth
                value={
                  field.value && isStatic && textParser
                    ? textParser(field.value)
                    : field.value
                }
                multiline={multiline}
                rows={multiline ? rows : undefined}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                disabled={disabled || isStatic || isProcessing}
              />
            </FormGroup>
          )}
        />
      </UserAttributeMetadataPaper>
    </Grid>
  );
};

export default FormTextField;
